import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  AddressService,
  IAddress,
  IPartialAddress,
} from "../../services/address.service";
import { AlertController, ModalController } from "@ionic/angular";
import { AddressEditorModalComponent } from "../address-editor-modal/address-editor-modal.component";
import { LoaderService } from "../../services/loader.service";
import { FormatAddressPipe } from "../../pipes/address.form.pipe";
import { IStore } from "src/app/store/services/store.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { finalize } from "rxjs/operators";
import { AlertService } from "../../services/alert.service";
import { SettingService } from "../../services/setting.service";
import { AddressEditorDesktopModalComponent } from "../address-editor-desktop-modal/address-editor-desktop-modal.component";
import { ValidatorsService } from "../../services/validators.service";
import { TranslationService } from "../../services/translation.service";

@Component({
    selector: "shared-address-desktop",
    templateUrl: "./address-desktop.component.html",
    styleUrls: ["./address-desktop.component.scss"],
    standalone: false
})
export class AddressDesktopComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  store: IStore;

  @Input() placeHolder: string;
  @Input() submitted: boolean;
  @Input() skipProvinceValidation: boolean = false;
  @Input() isReservation: boolean;
  @Output() onChange: EventEmitter<IAddress> = new EventEmitter<IAddress>();
  @Input() desktop = false;
  onPostalCodeValidated: EventEmitter<IPartialAddress[]> = new EventEmitter<
    IPartialAddress[]
  >();

  patternReference: any = {};

  address: IAddress;

  get text() {
    if (!this.address) return this.placeHolder;

    return this.formatAddress.transform(this.address);
  }

  constructor(
    private modalCtrl: ModalController,
    private formatAddress: FormatAddressPipe,
    private loader: LoaderService,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private addressService: AddressService,
    private alertService: AlertService,
    public settingService: SettingService,
    //private translateService: TranslateService,
    private translationService: TranslationService,
    private alertCtrl: AlertController,
    public validators: ValidatorsService
  ) {}

  ngOnInit() {
    /*
    this.form = this.fb.group({
      postalCode: ["", this.validators.formBuilderValidationInitializer(true)],
    });
    */
    this.form = this.fb.group({
      postalCode: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      postalCode: null
    };
    */
    this.patternReference = {
      postalCode: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
  }

  async beginChangeAddress() {
    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    this.validate();
    const modal = await this.modalCtrl.create({
      component: AddressEditorDesktopModalComponent,
      componentProps: {
        skipProvinceValidation: this.skipProvinceValidation,
        isReservation: this.isReservation,
        postalCode: this.form.get("postalCode").value,
      },
      cssClass: "custom-border-modal-css",
    });

    modal.onDidDismiss().then(async (result) => {
      if (!result.data) return;

      this.address = result.data;
      this.onChange.emit(this.address);
    });

    await modal.present();
  }

  alertNoDelivery() {
    this.alertCtrl
      .create({
        header: this.translationService.translate(
          "Checkout.WrongPostalCodeHeading"
        ),
        message: this.translationService.translate ("Checkout.WrongPostalCode"),
        buttons: [
          {
            text: "Okay",
            role: "cancel",
            cssClass: "secondary",
            handler: () => {},
          },
        ],
      })
      .then((al) => {
        al.present();
      });
    this.form.get("postalCode").setValue("");
  }

  validate() {
    //Postal code custom validation
    //Might consider changing it to mask later
    let postalLength: number = this.form.get("postalCode").value;
    //Must be in UpperCase to match the SeeMyStore postal code validation
    this.form.get("postalCode").setValue(postalLength.toString().toUpperCase());

    if (postalLength.toString().length > 7) {
      this.form
        .get("postalCode")
        .setValue(postalLength.toString().substring(0, 7));
    }
  }
}
